module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_88-f1a9b1e50ba45a0bc8f1d16f1cc76d85.png";